/**
 * Hardcoded dashboard samples for local/dev (NODE_ENV !== 'production').
 */
import moment from 'moment'

const daysAgo = n =>
  moment()
    .subtract(n, 'days')
    .toISOString()

export const statusCounts = {
  open: 3,
  processing: 5,
  onhold: 2,
  complete: 41
}

export const periodCounts = {
  month: 8,
  year: 51
}

/** vs previous period, percent */
export const metricTrends = {
  open: 12,
  processing: -8,
  onhold: 5,
  complete: 20,
  month: 14,
  year: 9
}

export const metricSparklines = {
  open: [2, 3, 2, 4, 3, 5, 3],
  processing: [4, 5, 6, 4, 7, 5, 5],
  onhold: [1, 2, 1, 3, 2, 1, 2],
  complete: [28, 30, 32, 35, 37, 39, 41],
  month: [3, 4, 5, 4, 6, 7, 8],
  year: [30, 34, 38, 42, 45, 48, 51]
}

/** Ordered to match dashboard foamTypes: f32, rg50, rg70, ld24, s4044, mix */
export const foamQuantities = [18, 12, 7, 4, 3, 5]

/** Ordered to match millTypes: mill_seat, mill_mattress, mill_std, mill_seat_back, mill_other */
export const millQuantities = [22, 8, 6, 5, 3]

/** Sample model-type monthly stats for the model chart (dev) */
export const modelTypeStatsDev = (() => {
  const year = moment().year()
  const samples = [
    { model_type: 'full_seat', months: [2, 1, 3, 2, 4, 3, 2, 3, 2, 1, 2, 3] },
    { model_type: 'seat_only', months: [1, 0, 1, 2, 1, 1, 0, 2, 1, 1, 0, 1] },
    { model_type: 'relax', months: [0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 1] },
    { model_type: 'full_mattress', months: [0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0] }
  ]
  const rows = []
  samples.forEach(sample => {
    sample.months.forEach((quantity, index) => {
      if (!quantity) return
      rows.push({
        model_type: sample.model_type,
        type: 'custom_seat',
        year,
        month: index + 1,
        week: index + 1,
        quantity
      })
    })
  })
  return rows
})()

/** Orders by web form type (YTD) */
export const ordersByType = [
  { type: 'custom_seat', quantity: 28 },
  { type: 'std_seat', quantity: 9 },
  { type: 'abs_thermo', quantity: 5 },
  { type: 'upholstry', quantity: 4 },
  { type: 'pkf', quantity: 3 },
  { type: 'runner', quantity: 2 }
]

export const recentOrders = [
  {
    id: 'dev-order-1',
    reference: 'PAT-2026-0142',
    quantity: 1,
    status: 'processing',
    submitted_at: daysAgo(1),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0142_F32.stl',
      file_size: 2456789
    },
    file_id: 'dev-file-1',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'full_seat',
      foam_type: 'f32',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Rehab Clinic Antwerp',
      city: 'Antwerpen',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-2',
    reference: 'PAT-2026-0138',
    quantity: 2,
    status: 'open',
    submitted_at: daysAgo(3),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0138_RG50.stl',
      file_size: 3120456
    },
    file_id: 'dev-file-2',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'seat_only',
      foam_type: 'rg50',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Rehab Clinic Antwerp',
      city: 'Antwerpen',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-3',
    reference: 'PAT-2026-0129',
    quantity: 1,
    status: 'onhold',
    submitted_at: daysAgo(6),
    is_submitted: true,
    file: null,
    file_id: null,
    item: {
      short_description: 'Custom Mattress'
    },
    form_data: {
      model_type: 'full_mattress',
      foam_type: 'mix',
      mix_seat_foam_type: 'rg70',
      mix_back_foam_type: 'f32',
      is_remill: false
    },
    shipping_address: {
      company_name: 'OMS Demo Warehouse',
      city: 'Gent',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-4',
    reference: 'PAT-2026-0115',
    quantity: 1,
    status: 'complete',
    submitted_at: daysAgo(14),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0115_LD24.stl',
      file_size: 1987654
    },
    file_id: 'dev-file-4',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'full_seat',
      foam_type: 'ld24',
      is_remill: true
    },
    shipping_address: {
      company_name: 'Home Care Brugge',
      city: 'Brugge',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-5',
    reference: null,
    quantity: 1,
    status: 'complete',
    submitted_at: daysAgo(21),
    is_submitted: true,
    file: null,
    file_id: null,
    item: {
      short_description: 'Standard Seat'
    },
    form_data: {
      model_type: 'acto',
      foam_type: 's4044',
      is_remill: false
    },
    shipping_address: null
  },
  {
    id: 'dev-order-6',
    reference: 'PAT-2026-0102',
    quantity: 1,
    status: 'complete',
    submitted_at: daysAgo(28),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0102_F32.stl',
      file_size: 2200111
    },
    file_id: 'dev-file-6',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'relax',
      foam_type: 'f32',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Rehab Clinic Antwerp',
      city: 'Antwerpen',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-7',
    reference: 'PAT-2026-0151',
    quantity: 1,
    status: 'open',
    submitted_at: daysAgo(0),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0151_RG70.stl',
      file_size: 2789012
    },
    file_id: 'dev-file-7',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'full_seat',
      foam_type: 'rg70',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Physio Center Leuven',
      city: 'Leuven',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-8',
    reference: 'PAT-2026-0148',
    quantity: 3,
    status: 'processing',
    submitted_at: daysAgo(2),
    is_submitted: true,
    file: null,
    file_id: null,
    item: {
      short_description: 'ABS Thermoforming'
    },
    form_data: {
      model_type: null,
      foam_type: null,
      is_remill: false
    },
    shipping_address: {
      company_name: 'Home Care Brugge',
      city: 'Brugge',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-9',
    reference: 'PAT-2026-0140',
    quantity: 1,
    status: 'processing',
    submitted_at: daysAgo(4),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0140_F32.stl',
      file_size: 2011455
    },
    file_id: 'dev-file-9',
    item: {
      short_description: 'Custom Milled Seat'
    },
    form_data: {
      model_type: 'seat_only',
      foam_type: 'f32',
      is_remill: true
    },
    shipping_address: {
      company_name: 'Rehab Clinic Antwerp',
      city: 'Antwerpen',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-10',
    reference: 'UPH-2026-0044',
    quantity: 2,
    status: 'onhold',
    submitted_at: daysAgo(8),
    is_submitted: true,
    file: null,
    file_id: null,
    item: {
      short_description: 'Upholstery'
    },
    form_data: {
      model_type: null,
      foam_type: null,
      is_remill: false
    },
    shipping_address: {
      company_name: 'OMS Demo Warehouse',
      city: 'Gent',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-11',
    reference: 'STD-2026-0088',
    quantity: 1,
    status: 'complete',
    submitted_at: daysAgo(35),
    is_submitted: true,
    file: null,
    file_id: null,
    item: {
      short_description: 'Standard Seat'
    },
    form_data: {
      model_type: 'assmann',
      foam_type: 'rg50',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Physio Center Leuven',
      city: 'Leuven',
      country_code: 'BE'
    }
  },
  {
    id: 'dev-order-12',
    reference: 'PAT-2026-0091',
    quantity: 1,
    status: 'complete',
    submitted_at: daysAgo(42),
    is_submitted: true,
    file: {
      file_name: 'PAT-2026-0091_S4044.stl',
      file_size: 1890123
    },
    file_id: 'dev-file-12',
    item: {
      short_description: 'Custom Mattress'
    },
    form_data: {
      model_type: 'full_mattress',
      foam_type: 's4044',
      is_remill: false
    },
    shipping_address: {
      company_name: 'Home Care Brugge',
      city: 'Brugge',
      country_code: 'BE'
    }
  }
]

export const isDashboardDev = () => process.env.NODE_ENV !== 'production'

/** Use live counts when DB has any data; otherwise fall back to hardcoded in dev. */
export function withDevCounts (liveCounts, fallbackCounts) {
  if (!isDashboardDev()) return liveCounts
  const total = Object.values(liveCounts || {}).reduce(
    (sum, value) => sum + (Number(value) || 0),
    0
  )
  if (total > 0) return liveCounts
  return { ...fallbackCounts }
}

/** Prefer live rows; in dev, append hardcoded rows that are not already present. */
export function withDevRows (liveRows, fallbackRows, options = {}) {
  const { key = 'key', length } = options
  const live = liveRows || []
  if (!isDashboardDev()) {
    return length ? live.slice(0, length) : live
  }
  if (!live.length) {
    return length ? fallbackRows.slice(0, length) : [...fallbackRows]
  }
  const seen = new Set(live.map(row => row[key]))
  const extras = fallbackRows.filter(row => !seen.has(row[key]))
  const merged = [...live, ...extras]
  return length ? merged.slice(0, length) : merged
}

/** Prefer live list items; in dev, pad with hardcoded samples up to length. */
export function withDevList (liveItems, fallbackItems, length) {
  const live = liveItems || []
  if (!isDashboardDev()) return live.slice(0, length)
  if (!live.length) return fallbackItems.slice(0, length)
  const seen = new Set(live.map(item => item.id))
  const extras = fallbackItems.filter(item => !seen.has(item.id))
  return [...live, ...extras].slice(0, length)
}

function matchesOrderNeedle (item, needle) {
  if (!needle) return true
  const q = String(needle).trim().toLowerCase()
  if (!q) return true
  const haystack = [
    item.reference,
    item.status,
    item.item && item.item.short_description,
    item.form_data && item.form_data.foam_type,
    item.form_data && item.form_data.model_type,
    item.shipping_address && item.shipping_address.company_name,
    item.shipping_address && item.shipping_address.city
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return haystack.includes(q)
}

/**
 * Prefer live orders; in dev, always merge in matching sample rows
 * (and fall back fully when the API returns none).
 */
export function withDevOrdersPage (
  livePage,
  fallbackItems,
  { status, needle, page = 1, pageSize = 50 } = {}
) {
  const liveItems = (livePage && livePage.items) || []
  const liveTotal = livePage && livePage.total_rows

  if (!isDashboardDev()) {
    return {
      items: liveItems,
      total_rows: liveTotal != null ? liveTotal : liveItems.length
    }
  }

  let fallback = [...(fallbackItems || [])]
  if (status) fallback = fallback.filter(item => item.status === status)
  fallback = fallback.filter(item => matchesOrderNeedle(item, needle))

  if (!liveItems.length && !(liveTotal > 0)) {
    const size = pageSize === 'All' || pageSize < 0 ? fallback.length : pageSize
    const start = size ? (Math.max(page, 1) - 1) * size : 0
    return {
      items: size ? fallback.slice(start, start + size) : fallback,
      total_rows: fallback.length
    }
  }

  const seen = new Set(liveItems.map(item => item.id))
  const extras = fallback.filter(item => !seen.has(item.id))
  const size = pageSize === 'All' || pageSize < 0 ? Infinity : pageSize
  const room = Number.isFinite(size)
    ? Math.max(0, size - liveItems.length)
    : extras.length
  const merged =
    page <= 1 ? [...liveItems, ...extras.slice(0, room)] : liveItems

  return {
    items: merged,
    total_rows:
      (liveTotal != null ? liveTotal : liveItems.length) + extras.length
  }
}

/** Prefer live scalar; fall back to hardcoded in dev when empty/zero. */
export function withDevValue (liveValue, fallbackValue) {
  if (!isDashboardDev()) return liveValue
  if (liveValue == null || liveValue === 0 || liveValue === '') {
    return fallbackValue
  }
  return liveValue
}

export default {
  statusCounts,
  periodCounts,
  metricTrends,
  metricSparklines,
  foamQuantities,
  millQuantities,
  modelTypeStatsDev,
  ordersByType,
  recentOrders,
  isDashboardDev,
  withDevCounts,
  withDevRows,
  withDevList,
  withDevOrdersPage,
  withDevValue
}
